import React from 'react';
import type { UAPPlacementComponentProps } from '../@types';

export const ThreeDot = ({
  threeDotClassName,
}: UAPPlacementComponentProps) => (
  <svg className={threeDotClassName} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 9C5 9.55229 4.55228 10 4 10C3.44772 10 3 9.55229 3 9C3 8.44772 3.44772 8 4 8C4.55228 8 5 8.44772 5 9ZM9 9C9 9.55229 8.55229 10 8 10C7.44772 10 7 9.55229 7 9C7 8.44772 7.44772 8 8 8C8.55229 8 9 8.44772 9 9ZM12 10C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9C11 9.55229 11.4477 10 12 10Z" fill="#212121" />
  </svg>
);
